import * as actionTypes from "../actions/actionTypes";

const initialState = {
  hmgListSelected: [],
};

export const notifications = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_NOTIF_HMG_LIST:
      return {
        ...state,
        hmgListSelected: action.value,
      };
    default:
      return state;
  }
};

export default notifications;
